export default __webpack_public_path__ + "static/media/audit.7d3801fe.png";